/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-map-settings',
  templateUrl: './map-settings.component.html',
  styleUrls: ['./map-settings.component.scss']
})
export class MapSettingsComponent implements OnInit {

  settings: any = {
    'overlay_routes': false,
    'overlay_territories': false
  };

  constructor(
    public dialogRef: MatDialogRef<MapSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  toggleOverlay(state: any): void {
    this.settings[state] = !this.settings[state];
  }

  saveSettings(): void {
    this.dialogRef.close(this.settings);
  }

  closeDrawer(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.settings = this.dialogData?.data?.settings;
  }

}
